RivalIQ.apps.SocialPosts.module('mixins', function (mixins, App, Backbone, Marionette, $, _, s) {

    'use strict';

    mixins.PostTablesLoadData = {
        loadData: function () {
            const me = this;

            const parentLoad = RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData.apply(me, arguments);

            return $.when(
                RivalIQ.postTags.data.PostTags.fetch(),
                parentLoad
            ).then(function (postTags) {
                me.dashboardModel.postTagsById = _.keyBy(postTags, 'id');
            });
        }
    };

    const POSTS_TAG_CHANGE_REFRESH_TIME_MS = 2000;

    // Reloads the widget if a postTag was added or removed from a post such that the post no longer matches
    // the query filters.
    mixins.PostTagsReload = _.defaults({
        postTagManagerEvents: {
            'postTag:applied': 'onPostTagApplicationChange',
            'postTag:unapplied': 'onPostTagApplicationChange',
            'postTag:application:saved': 'onPostTagApplicationChange'
        },

        postMatchesPostTagIdsFilter: function (post) {
            const me = this;

            const postTagIds = _(RivalIQ.postTags.utils.getPostTagIds(me.getProp('postTagIds')))
                .map(function (postTagId) {
                    return (postTagId === '__UNTAGGED__' ? postTagId : Number(postTagId));
                })
                .value();

            if (_.isEmpty(postTagIds) || !post) {
                // we're not filtering by postTagId
                return true;
            }

            const postTagExclude = me.getProp('postTagExclude');
            const postTagIdsOnPost = post.get('post_tag_ids');

            const postIsUntagged = postTagIdsOnPost.length === 0;
            const filterIncludesUntagged = _.includes(postTagIds, '__UNTAGGED__');

            if (filterIncludesUntagged && postIsUntagged) {
                return !postTagExclude;
            }

            let postMatches;
            if (me.getProp('postTagConjunction') === 'AND') {
                postMatches = _.intersection(postTagIds, postTagIdsOnPost).length === postTagIds.length;
            } else {
                postMatches = _.intersection(postTagIds, postTagIdsOnPost).length > 0;
            }

            if (postMatches) {
                return !postTagExclude;
            } else {
                return postTagExclude;
            }
        },

        onPostTagApplicationChange: function (postTag, post) {
            const me = this;

            const postStillMatches = me.postMatchesPostTagIdsFilter(post);
            if (!postStillMatches || me.reloadOnAnyPostTagChange) {

                if (!me._reloadFcn) {
                    me._reloadFcn = _.debounce(function () {
                        me.reload();
                    }, POSTS_TAG_CHANGE_REFRESH_TIME_MS);
                }

                if (me.showLoadingView) {
                    me.showLoadingView();
                }
                me._reloadFcn();
            }
        }

    }, RivalIQ.postTags.mixins.PostTagsEventingMixin);
});
